export const isOnProjectDetailPage = (pathname: string): boolean =>
  /\/projects\/(?!(all|dashboard|timeline)(\/|$))[^/]+/.test(pathname) &&
  !pathname.includes("/teams/");
